import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
import { updatePortalElement } from '@cloud-sn/v-utils';
import { buildComponentName } from '../utils';
import { calcMultipleSearchInputWidth } from './utils';
import SubMixin from './mixins/sub';
export default {
  name: buildComponentName('TreeSelectSearchInput'),
  mixins: [SubMixin],
  props: {
    align: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      inputStyle: null
    };
  },
  computed: {
    prefixCls: function prefixCls() {
      return this.rootPrefixCls;
    }
  },
  watch: {
    rootInnerVisible: function rootInnerVisible(nVal) {
      if (nVal) {
        this.activeInput();
      }
    },
    rootSearchInputValue: function rootSearchInputValue(nVal, oVal) {
      var _this = this;

      var align = this.align,
          inputMirror = this.$refs.inputMirror;

      if (align && inputMirror && nVal !== oVal) {
        this.$nextTick(function () {
          _this.inputStyle = calcMultipleSearchInputWidth(nVal, inputMirror);
        });
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    var rootIsMultiple = this.rootIsMultiple;

    if (!rootIsMultiple) {
      // 防止元素渲染位置不对,导致滚动条滚动
      setTimeout(function () {
        _this2.activeInput();
      }, 0);
    }
  },
  methods: {
    focus: function focus() {
      var inputRef = this.$refs.inputRef;

      if (inputRef) {
        inputRef.focus();
      }
    },
    blur: function blur() {
      var inputRef = this.$refs.inputRef;

      if (inputRef) {
        inputRef.blur();
      }
    },
    activeInput: function activeInput() {
      var _this3 = this;

      var rootTriggerRef = this.rootTriggerRef,
          rootIsMultiple = this.rootIsMultiple;

      if (!rootIsMultiple) {
        if (rootTriggerRef) {
          updatePortalElement(rootTriggerRef.getPortalPopupElement(), function () {
            _this3.focus();
          });
        }
      } else {
        this.focus();
      }
    },
    onInput: function onInput(e) {
      var value = e.target.value;
      this.onSearchInput(e, value);
    },
    onPlaceholderClick: function onPlaceholderClick() {
      this.focus();
    },
    renderPlaceholder: function renderPlaceholder() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          rootSearchPlaceholder = this.rootSearchPlaceholder,
          rootIsMultiple = this.rootIsMultiple,
          rootSearchInputValue = this.rootSearchInputValue,
          onPlaceholderClick = this.onPlaceholderClick;
      return rootSearchPlaceholder && !rootIsMultiple && !rootSearchInputValue ? h("span", {
        "class": "".concat(prefixCls, "-search__field__placeholder"),
        "on": {
          "click": onPlaceholderClick
        }
      }, [rootSearchPlaceholder]) : null;
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        inputStyle = this.inputStyle,
        renderPlaceholder = this.renderPlaceholder,
        rootSearchInputValue = this.rootSearchInputValue,
        onInput = this.onInput;
    var attrs = {
      type: 'text'
    };
    var domProps = {
      value: rootSearchInputValue
    };
    var on = {
      input: onInput
    };
    return h("span", {
      "class": "".concat(prefixCls, "-search__field__wrap")
    }, [h("input", _mergeJSXProps([{}, {
      class: "".concat(prefixCls, "-search__field"),
      style: inputStyle,
      attrs: attrs,
      domProps: domProps,
      on: on,
      ref: 'inputRef'
    }])), h("span", {
      "class": "".concat(prefixCls, "-search__field__mirror"),
      "ref": "inputMirror"
    }, [rootSearchInputValue, "\xA0\xA0"]), renderPlaceholder()]);
  }
};